"use strict";

var _core = require("@citation-js/core");

var _input = require("./input");

_core.plugins.add(_input.ref, {
  input: _input.formats
});